module.exports = __webpack_public_path__ + "static/media/preet.8f596856.png";